import React, { useEffect, useRef } from 'react';

function EditorialShowcase() {
  const videoLeftRef = useRef(null);
  const videoRightRef = useRef(null);

  useEffect(() => {
    const forceAutoplay = (videoRef) => {
      if (videoRef.current) {
        videoRef.current.muted = true;
        videoRef.current.play().catch((err) => console.log("Autoplay block handle:", err));
      }
    };
    forceAutoplay(videoLeftRef);
    forceAutoplay(videoRightRef);
  }, []);

  return (
    <div className="luxury-editorial-container">
      
      {/* ==========================================================================
         SECTION 1: IMAGE (LEFT) & VIDEO (RIGHT)
         ========================================================================== */}
      <section className="editorial-row">
        <div className="container-fluid p-0">
          <div className="row g-0 align-items-stretch">
            
            {/* LEFT COLUMN: Heading + Image + LOOKBOOK Text */}
            <div className="col-md-6 position-relative grey-bg-canvas d-flex flex-column justify-content-between">
              <div className="section-title-wrapper text-center w-100 pt-5">
                <h2 className="editorial-title">What’s up</h2>
                <h3 className="editorial-title-stroke">at Orangeapes</h3>
              </div>
              
              <div className="editorial-image-box split-image-left ms-auto me-lg-5 mb-5">
                <img 
                  src={`${process.env.PUBLIC_URL}/assets/videos/bag08.jpg`}
                  className="fit-editorial-asset pt-4"
                />
              </div>
              <div className="vertical-rotated-tag tag-left">LOOKBOOK</div>
            </div>

            {/* RIGHT COLUMN: Featured Button (Right-Sticky) + Video + COLLECTION Text */}
            <div className="col-md-6 position-relative white-bg-canvas d-flex flex-column justify-content-between">
              {/* 🌟 RIGHT EDGE STICKY CONTAINER FOR FEATURED BUTTON */}
              <div className="featured-btn-header-sticky w-100 position-relative pt-5 ">
                <button className="editorial-black-btn sticky-right-btn">FEATURED PRODUCT</button>
              </div>

              <div className="editorial-video-box split-video-right me-auto ms-lg-5 mb-5">
                <video
  ref={videoRightRef}
  className="fit-editorial-asset"
  loop
  muted
  playsInline
  autoPlay
  preload="auto"
  poster={`${process.env.PUBLIC_URL}/assets/videos/bag01.jpg`}
>
  <source
    src={`${process.env.PUBLIC_URL}/assets/videos/bag01.mp4`}
    type="video/mp4"
  />
</video>
              </div>
              <div className="vertical-rotated-tag tag-right">COLLECTION</div>
            </div>

          </div>
        </div>
      </section>

      {/* ==========================================================================
         SECTION 2: VIDEO (LEFT) & IMAGE (RIGHT)
         ========================================================================== */}
      <section className="editorial-row">
        <div className="container-fluid p-0">
          <div className="row g-0 align-items-stretch">
            
            {/* LEFT COLUMN: Title + Video + Trending strip bar button */}
            <div className="col-md-6 position-relative grey-bg-canvas d-flex flex-column justify-content-between text-center">
              <div className="caption-header-text pt-4">
                <h4 className="editorial-caption-title">Girl on top</h4>
              </div>

              <div className="editorial-video-box split-video-left ms-auto me-lg-5 mb-4">
                <video
  ref={videoLeftRef}
  className="fit-editorial-asset"
  loop
  muted
  playsInline
  autoPlay
  preload="auto"
  poster={`${process.env.PUBLIC_URL}/assets/videos/bag03.jpg`}
>
  <source
    src={`${process.env.PUBLIC_URL}/assets/videos/bag03.mp4`}
    type="video/mp4"
  />
</video>
              </div>

              <div className="trending-footer-strip w-100 text-start ms-auto me-lg-5 mb-5">
                <button className="editorial-strip-btn">TRENDING</button>
              </div>
            </div>

            {/* RIGHT COLUMN: Title + Image */}
            <div className="col-md-6 position-relative white-bg-canvas d-flex flex-column justify-content-start text-center">
              <div className="caption-header-text pt-4 mb-4">
                <h4 className="editorial-caption-title">HANDBAG</h4>
              </div>

              <div className="editorial-image-box split-image-right me-auto ms-lg-5">
                <img 
                  src={`${process.env.PUBLIC_URL}/assets/videos/bag07.jpg`} 
                  alt="Featured Black Handbag" 
                  className="fit-editorial-asset"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}

export default EditorialShowcase;